















import { Component, Mixins } from "vue-property-decorator";
import { default as MediaSelectableContentMixin } from "./mixins/MediaSelectableContentMixin.vue";
import { ClaioImageSelectableDialog } from "./dialogs";
import { FatalIndicator } from "./common";
import { IExecutable } from "./IExecutable";
import { instanceOfIFixedTextIndicatable } from "../../../../../../domain/format";
import { Patient } from "../../../../../../domain/patient";
import { Department } from "../../../../../../domain/department";

@Component({
  components: {
    ClaioImageSelectableDialog,
    FatalIndicator,
  }
})
export default class WizardContentClaioImageSelector extends Mixins(MediaSelectableContentMixin) implements IExecutable {
  $refs!: {
    dialog: ClaioImageSelectableDialog,
  };

  get text(): string {
    return instanceOfIFixedTextIndicatable(this.content)
      ? this.content.fixedText
      : "Claio画像";
  }

  get patient(): Patient {
    return !!this.attributes.patient
      ? this.attributes.patient
      : null;
  }

  get department(): Department {
    return !!this.attributes.department
      ? this.attributes.department
      : null;
  }

  get orderNo(): string {
    return !!this.attributes.orderNo
      ? this.attributes.orderNo
      : null;
  }

  async execute() {
    const result = await this.$refs.dialog.show();
    if (!!result) {
      this.registerClaioImage(result.patientId, result.claioImageKey, result.departmentId, result.isVisibleLayer, result.isMovie, result.isSecret);
    }
  }
}
